/** Default / fallback marketplace (also used while geo is loading). */
export const AMAZON_SIGNAGE_STICK_US_BUY_URL =
  "https://www.amazon.com/dp/B0D4FCG9MX/ref=pmkt_cmspickcel_web";

/** Country-code → Amazon marketplace product URL for the Signage Stick. */
export const AMAZON_SIGNAGE_STICK_BUY_URLS: Record<string, string> = {
  US: AMAZON_SIGNAGE_STICK_US_BUY_URL,
  DE: "https://www.amazon.de/dp/B0DWSH8TV6/ref=pmkt_cmspickcel_webde",
  ES: "https://www.amazon.es/dp/B0DWSH8TV6/ref=pmkt_cmspickcel_webes",
  FR: "https://www.amazon.fr/dp/B0DWSH8TV6/ref=pmkt_cmspickcel_webfr",
  IT: "https://www.amazon.it/dp/B0DWSH8TV6/ref=pmkt_cmspickcel_webit",
  GB: "https://www.amazon.co.uk/dp/B0DWSH8TV6/ref=pmkt_cmspickcel_webuk",
};

export function getAmazonSignageStickBuyUrl(countryCode?: string | null): string {
  if (!countryCode) return AMAZON_SIGNAGE_STICK_US_BUY_URL;
  return (
    AMAZON_SIGNAGE_STICK_BUY_URLS[countryCode.toUpperCase()] ??
    AMAZON_SIGNAGE_STICK_US_BUY_URL
  );
}
